import React from "react";
import type { ReactElement } from "react";
import CookieBanner from "./cookieBanner.component";

// Used by gatsby-browser and gatsby-ssr so the banner is on every page,
// including 404 (it renders nothing until the browser has checked the saved choice)
export default function RootWrapper({ element }: { element: ReactElement }) {
  return (
    <>
      {element}
      <CookieBanner />
    </>
  );
}
